import React from "react";
import { Paper, Typography, Box } from "@mui/material";
import { lighten } from "@mui/material/styles";
import DoneIcon from "@mui/icons-material/Done";
import DoneAllIcon from "@mui/icons-material/DoneAll";

const ChatBubble = ({ msg, theme }) => {
  const isMine = msg.isMine;
  const isDoctor = msg.senderType === "doctor";

  const renderStatusIcon = () => {
    if (!isMine) return null;

    if (msg.status === "read") {
      return (
        <DoneAllIcon sx={{ ml: 0.5, color: "#4fc3f7" }} fontSize="small" />
      );
    }

    if (msg.status === "sent") {
      return <DoneIcon sx={{ ml: 0.5 }} fontSize="small" />;
    }

    if (msg.status === "sending") {
      return (
        <Typography variant="caption" sx={{ ml: 0.5 }}>
          Sending...
        </Typography>
      );
    }

    return null;
  };

  return (
    <Paper
      elevation={1}
      sx={{
        p: 1.5,
        maxWidth: "70%",
        bgcolor: isMine ? lighten(theme.palette.primary.main, 0.5) : "#ffffff",
      }}
    >
      {!isMine && (
        <Typography
          variant="caption"
          sx={{
            fontWeight: 600,
            display: "block",
            mb: 0.3,
            color: isDoctor ? "#1976d2" : theme.palette.primary.main,
          }}
        >
          {msg.senderName}
        </Typography>
      )}

      <Typography variant="body2">{msg.message_content}</Typography>

      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          mt: 0.5,
        }}
      >
        <Typography variant="caption" sx={{ opacity: 0.6 }}>
          {new Date(msg.created_date).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </Typography>

        {renderStatusIcon()}
      </Box>
    </Paper>
  );
};

export default ChatBubble;
